import { createSlice } from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'

const initialState = {
    list: null,
    teamData: null,
    scoreData: null,
    exportScoreInput: null
}

const ordersSlice = createSlice({
    name: "teams",
    initialState,
    reducers: {
        setTeamList: (state, action) => {
            state.list = action.payload
        },
        setTeamData: (state, action) => {
            state.teamData = action.payload
        },
        setScoreData: (state, action) => {
            state.scoreData = action.payload
        },
        setExportScoreInput: (state, action) => {
            state.exportScoreInput = action.payload
        }
    }
})

export const { setTeamList, setTeamData, setScoreData, setExportScoreInput } = ordersSlice.actions

export const getTeamsListThunk = () => {
    return async (dispatch) => {
        try {
            let res = await hit("/admins/teams?populate=createdBy", "get")
            if (!res.err) {
                dispatch(setTeamList(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load teams", severity: "error" }))
            }
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to load teams", severity: "error" }))
        }
    }
}

export const getTeamDetail = (id) => {
    return async (dispatch) => {
        try {
            let res = await hit(`/admins/team/${id}`, "get")
            if (!res.err) {
                dispatch(setTeamData(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load team detail", severity: "error" }))
            }
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to load team detail", severity: "error" }))
        }
    }
}

export const exportTeamScore = (id, startDate=null, endDate=null, type, members) => {
    return async (dispatch) => {
        try {
            let query = ''
            if(startDate && endDate) {
                query = `&start_date=${startDate}&end_date=${endDate}`
            }
            let res = await hit(`/scores/team_scores?groups=${id}${query}`, "get")
            if (!res.err) {
                dispatch(setExportScoreInput({team_id: id, startDate, endDate, type, members}))
                dispatch(setScoreData(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to export team score", severity: "error" }))
            }
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to export team score", severity: "error" }))
        }
    }
}

export default ordersSlice.reducer